import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { PopoverController } from "ionic-angular";
import { SelectPopoverComponent } from "./select-popover-component";

interface SelectOption {
  value: string;
  description: string;
}

export class BaseControlValueAccessor<T> implements ControlValueAccessor {
  public disabled = false;
  @Output()
  valueChanged: EventEmitter<any> = new EventEmitter<any>();

  public onChange(newVal: string) {}

  public onTouched(_?: any) {}

  public value: SelectOption;

  public writeValue(obj: SelectOption): void {
    this.value = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}

@Component({
  selector: "single-select-dropdown",
  templateUrl: "single-select-dropdown.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SingleSelectDropdownComponent),
    },
  ],
})
export class SingleSelectDropdownComponent extends BaseControlValueAccessor<string> {
  @ViewChild("select") select;
  @Input() options: SelectOption[];
  @Input() placeholder: string;
  @Input() id: string;

  constructor(public popover: PopoverController) {
    super();
  }

  ngOnInit() {}

  public writeValue(option: any): void {
    if (typeof option === "string")
      option = this.options.find((opt) => opt.value === option);

    if (!option) {
      option = {
        value: null,
        description: this.placeholder,
      };
    }
    super.writeValue(option);
  }

  openSelect(event) {
    const popover = this.popover.create(
      SelectPopoverComponent,
      {
        options: this.options,
        width: this.select.nativeElement.offsetWidth - 17,
        selectedOption: this.value.value,
      },
      { cssClass: "select-popover his-dropdown" }
    );
    popover.onDidDismiss((option: SelectOption) => {
      if (option) {
        this.writeValue(option);
        this.onChange(option.value);
      }
    });

    const initialTopValue = event.target.getBoundingClientRect().top;
    let left = event.target.getBoundingClientRect().left;

    if (window.navigator.userAgent.indexOf("iPad") !== -1) {
      left += this.select.nativeElement.offsetWidth / 2;
    }

    const ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: initialTopValue + this.select.nativeElement.offsetHeight,
            left,
          };
        },
      },
    };
    popover.present({ ev });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/single-select-dropdown/single-select-dropdown.ts